import React from 'react';
import './Footer.css';  // Import footer-specific styles

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically

  return (
    <div className="footer">
      <p>Miami Home Holdings &copy; {currentYear} All rights reserved.</p>
    </div>
  );
};

export default Footer;
